import {ChangeDetectorRef, Directive, ElementRef, HostListener} from "@angular/core";
import {FUIAbstractInput} from "../../framework/abstract-input";

@Directive()
export abstract class FUIAbstractPasswordInput extends FUIAbstractInput {
    constructor(public elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    /**
     * Perform events after a click on the host
     * @param element
     */
    @HostListener("click")
    public override click(): void {
        this.focus();
    }
}
